import { render, staticRenderFns } from "./CalendarioHistoricoPantalla.vue?vue&type=template&id=6b95e5b2&"
import script from "./CalendarioHistoricoPantalla.vue?vue&type=script&lang=ts&"
export * from "./CalendarioHistoricoPantalla.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('6b95e5b2', component.options)
    } else {
      api.reload('6b95e5b2', component.options)
    }
    module.hot.accept("./CalendarioHistoricoPantalla.vue?vue&type=template&id=6b95e5b2&", function () {
      api.rerender('6b95e5b2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/Camaras/CalendarioHistorico/CalendarioHistoricoPantalla.vue"
export default component.exports